import { render, staticRenderFns } from "./PneuFabricante.vue?vue&type=template&id=254501ea&"
import script from "./PneuFabricante.vue?vue&type=script&lang=js&"
export * from "./PneuFabricante.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PneuFabricante.vue?vue&type=style&index=1&id=254501ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports